import Table from "react-bootstrap/Table";

import { User } from "@/@types/sintegrada/User";
import { ResumeGrouped } from "@/services/esus/attendanceService";
import { timeToString } from "@/utils/dateUtil";
import { MedicalAttendanceTypeEnum } from "@/utils/enums/MedicalAttendanceTypeEnum";

type Props = {
	aggregatedByProfessionalsAndMedicalAttendanceType: ResumeGrouped<
		User,
		ResumeGrouped<MedicalAttendanceTypeEnum, object>
	>[];
	averageTimeInSecondsByProfessional: ResumeGrouped<User, object>[];
};

export function AttendanceByProfessionalTable({
	aggregatedByProfessionalsAndMedicalAttendanceType,
	averageTimeInSecondsByProfessional,
}: Props) {
	return (
		<Table responsive striped bordered hover className="text-center">
			<thead>
				<tr className="fw-bolder">
					<th className="ps-2 text-start">Profissional</th>
					<th>Consultas</th>
					<th>Reavaliações</th>
					<th>Tempo médio de atendimento</th>
					<th className="pe-2 text-end">Total</th>
				</tr>
			</thead>
			<tbody>
				{aggregatedByProfessionalsAndMedicalAttendanceType
					.slice(0, 10)
					.map((professionalGroup, index) => (
						<tr key={`professional-medical-attendance-table-row-${index}`}>
							<td className="ps-2 text-start">
								{professionalGroup.key.name || "N/A"}
							</td>
							<td>
								{(professionalGroup.values || []).find(
									(attendanceTypeGroup) =>
										attendanceTypeGroup.key ===
										MedicalAttendanceTypeEnum.REQUESTED
								)?.total || 0}
							</td>
							<td>
								{(professionalGroup.values || []).find(
									(attendanceTypeGroup) =>
										attendanceTypeGroup.key ===
										MedicalAttendanceTypeEnum.EVALUATED
								)?.total || 0}
							</td>
							<td>
								{timeToString(
									averageTimeInSecondsByProfessional.find(
										(a) => a.key.id === professionalGroup.key.id
									)?.total || 0
								)}
							</td>
							<td className="pe-2 text-end">
								{(professionalGroup.values || [])
									.map((attendanceTypeGroup) => attendanceTypeGroup.total)
									.reduce((acc, curr) => acc + curr, 0)}
							</td>
						</tr>
					))}
			</tbody>
		</Table>
	);
}
